import { PageHero } from "@/components/common/PageHero";
import { InfraShowcase, TechShowcase, Ecosystem, MaterialHandling, ContactBand } from "@/components/home/Sections";
import { useSeo } from "@/hooks/useSeo";
import { IMAGES } from "@/data/site";

export default function Solutions() {
  useSeo({
    title: "Solutions | Industrial Infrastructure, Machinery & Automation — AutoMex",
    description: "Explore AutoMex solutions: industrial infrastructure, turnkey projects, PEB, industrial machinery, automation, material handling and industrial technology in Pune.",
    path: "/solutions",
  });
  return (
    <>
      <PageHero
        overline="Solutions"
        title="Infrastructure & Technology, End to End."
        subtitle="AutoMex delivers the full arc of industrial development — from factory infrastructure and turnkey execution to machinery, automation and material handling."
        image={IMAGES.tech}
        crumb="Solutions"
      />
      <InfraShowcase />
      <TechShowcase />
      <Ecosystem />
      <MaterialHandling />
      <ContactBand />
    </>
  );
}
